/** Map of all resolved path titles in details routes */
export const DETAILS_ROUTING_TITLE_MAP = {
    '': 'DETAILS_VIEW.HOME.TITLE',
    issues: 'DETAILS_VIEW.ISSUES.TITLE',
    timeline: 'DETAILS_VIEW.TIMELINE.TITLE',
    sessions: 'DETAILS_VIEW.SESSIONS.TITLE',
    'health-index': 'DETAILS_VIEW.HEALTH_INDEX.TITLE',
    tickets: 'DETAILS_VIEW.TICKETS.TITLE',
    restarts: 'DETAILS_VIEW.RESTARTS.TITLE',
    connection: 'DETAILS_VIEW.CONNECTION.TITLE',
    configuration: 'DETAILS_VIEW.CONFIGURATION.TITLE',
};
